export default __webpack_public_path__ + "static/improve-quality-of-life-hero-cfe2be5a9da16e28c4c2af217fa4db4d.webp";